module.exports = __webpack_public_path__ + "fonts/fa-brands-400.4c1da23.ttf";